export type ShopifyContextType = {
  reqAPIData: ReqAPIDataType,
  setReqAPIData: (user: ReqAPIDataType) => void,
  errorData: ErrorDataType,
  setErrorData: (data: ErrorDataType) => void,
  metaFields: MetaFieldType[],
  setMetaFields: (data: MetaFieldType[]) => void,
  codeFlexFieldList: MetaFieldType[],
  setCodeFlexFieldList: (data: MetaFieldType[]) => void,
  numericMetaFieldsList: MetaFieldType[],
  setNumericMetaFieldsList: (data: MetaFieldType[]) => void,
  dateMetaFieldsList: MetaFieldType[],
  setDateMetaFieldsList: (data: MetaFieldType[]) => void,
  selectedMetaFlexFieldsList: SelectedMFType[],
  setSelectedMetaFlexFieldsList: (data: SelectedMFType[]) => void,
  selectedMFFF: SelectedMFType[],
  setSelectedMFFF: (data: SelectedMFType[]) => void,
  taxConfigData: TaxConfigDataType,
  setTaxConfigData: (data: TaxConfigDataType) => void,
  productClassMFList: MetaFieldType[],
  setProductClassMFList: (data: MetaFieldType[]) => void,
  appData: AppDataType,
  setAppData: (data: AppDataType) => void
};

export type ReqAPIDataType = {
  hmacData: string,
  shopId: string,
  shopUrl: string
};

export const testConfirmationData = {
  hmacData: '',
  shopId: '',
  shopUrl: ''
};

export type ErrorDataType = {
  status: string | number,
  errorMessage: string,
  onboarded: boolean | undefined,
  uninstallMsg: string,
  link: string
};

export const testErrorData = {
  status: '',
  errorMessage: '',
  onboarded: undefined,
  uninstallMsg: '',
  link: ''
};

export type MetaFieldType = {
  ownerType: string,
  id: string,
  nameSpace: string,
  key: string,
  typeName: string,
  metaFieldName: string,
  flexFieldType: string
};

export type testMetaFieldTypeData = {
  ownerType: '',
  id: '',
  nameSpace: '',
  key: '',
  typeName: '',
  metaFieldName: '',
  flexFieldType: ''
};

export type DynamicObject = {
  [key: string]: any
};

export type ConnectOSeriesPayload = {
  hmacData: string,
  shopId: string,
  shopUrl: string,
  companyCode: string,
  clientID: string,
  clientSecret: string,
  calcAPIUrl: string,
  selectedIdp?: boolean
};

export type SelectedMFType = {
  flexFieldId: string | undefined,
  flexFieldType: string,
  metaFieldName: string,
  nameSpace: string,
  ownerType: string,
  shopId: string,
  shopUrl: string,
  version: number,
  selectedMFValue: string,
  id: string,
  selectedMFLabel: string,
  isNewSavedMF: boolean,
};

export type MFFFValidationErrorType = {
  isTwentyUniqueMetafields: boolean
};

export const emptyErrorData = {
  isTwentyUniqueMetafields: false
};

export type ReqParamsSaveMFFFType = {
  shopId: string,
  shopUrl: string,
  version: number
};

export interface MFDropDownType extends MetaFieldType {
  label: string,
  value: string
}

export type ReqHeadersTaxConfigType = {
  'X-Shopify-Shop-Domain': string,
  'X-Shopify-Shop-Id': string,
  'X-Shopify-Request-Id': string,
  'Content-Type': string
};

export type TaxConfigDataType = {
  tax_calc_url: string,
  client_id: string,
  company_code: string,
  shipping_code: string,
  gc_product_code: string,
  order_sync_enabled: boolean | undefined,
  idpMigrationFlag: boolean | undefined,
  is_Legacy_idp: boolean | undefined,
  sales_channel_enabled: boolean | undefined
};

export const testTaxConfigData = {
  tax_calc_url: '',
  client_id: '',
  company_code: '',
  shipping_code: '',
  gc_product_code: '',
  order_sync_enabled: undefined,
  idpMigrationFlag: undefined,
  is_Legacy_idp: undefined,
  sales_channel_enabled: undefined
};

export type EditTaxSettingsModalDataType = {
  shipping_code: string,
  gc_product_code: string,
  order_sync_enabled: boolean | undefined,
  sales_channel_enabled: boolean | undefined
};


export type PutReqHeadersTaxConfigType = {
  'X-Shopify-Shop-Domain': string,
  'X-Shopify-Request-Id': string,
};

export type BannerStatusType = 'success' | 'info' | 'warning' | 'critical';

export type AppDataType = {
  clientId: string,
  enableErrorLog: string,
  supplementaryBaseURL: string,
  enableDownloadXLSOption: string,
  isIDPEnabled: string,
  isSalesChannelEnabled: string
};

export const testAppData = {
  clientId: '',
  enableErrorLog: '',
  supplementaryBaseURL: '',
  enableDownloadXLSOption: '',
  isIDPEnabled: '',
  isSalesChannelEnabled: ''
};

export type ErrorLogsType = {
  errorType: string, 
  totalErrorCount: number
};

export type OnBoardingDetailsTypes = { 
  companyCode: string,
  clientID: string,
  clientSecret: string,
  calcAPIUrl: string,
  selectedIdp : boolean | undefined
};
